/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 TwitterLogin = {
    processing: false,
    connect: function() {
        $.ajax({
            url: '/a/user/twitterLogin',
            type: 'POST',
            dataType: 'json'
        }).done(function(data) {
            location.replace(data.authenticationUrl);
        });
    },
    init: function() {
        $(".connect-with-twitter").on('click', TwitterLogin.connect);
    }
};

$(document).ready(function() {
    TwitterLogin.init();
});
